export const QUERY_INVOICING_CONFIG_FOR_PAYER =
  "QUERY_INVOICING_CONFIG_FOR_PAYER";
export const QUERY_INVOICING_CONFIG_FOR_PAYEE =
  "QUERY_INVOICING_CONFIG_FOR_PAYEE";
